/*
 * @Description: 投稿模块
 * @Author: jiang.weiwei
 * @LastEditors: Please set LastEditors
 * @Date: 2017-12-06 19:46:00
 * @LastEditTime: 2022-03-14 14:06:02
 */
'use strict';
angular
    .module('submissionManageModule', [
        'submissionRouterModule',
        'personalLibraryModule', //个人稿库
        'pgcPersonalLibraryModule', //pgc个人稿库
        'submissionLibraryModule', //已投稿库
        'pgcSubmissionLibraryModule', //pgc已投稿库
        'rejectionManageModule', // 退稿稿库
        'explosionManageModule', //爆料管理
        'publishExplosionModule' //已发布爆料
    ])
    .controller('submissionManageCtrl', [function() {}]);
